import { isRejectedWithValue, Middleware } from "@reduxjs/toolkit";

/**
 * Log a warning and show a toast!
 */
export const errorLoggingMiddleware: Middleware = () => (next:any) => (action:any) => {
  if (isRejectedWithValue(action)) {
    // notificationController.error({ message: action.payload });
  }

  return next(action);
};
